import { rs, fmtDate } from "@/lib/format";

const Th = ({ children, r }) => <th className={`py-2 px-3 text-xs uppercase tracking-wider text-slate-500 font-semibold whitespace-nowrap ${r ? "text-right" : "text-left"}`}>{children}</th>;
const Td = ({ children, r, b, className = "" }) => <td className={`py-2 px-3 whitespace-nowrap ${r ? "text-right num" : ""} ${b ? "font-semibold" : ""} ${className}`}>{children}</td>;

export const splitPaidBy = (p) => {
  let h1 = 0, h2 = 0;
  Object.entries(p.by_date).forEach(([d, v]) => (Number(d.slice(8)) <= 15 ? (h1 += v) : (h2 += v)));
  return { h1, h2 };
};

export const PaidBySplit = ({ paidBy }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="paid-by-split">
    {paidBy.map((p) => {
      const { h1, h2 } = splitPaidBy(p);
      const un = p.name === "Unassigned";
      return (
        <div key={p.name} data-testid={`paid-by-card-${p.name}`} className={`rounded-xl border p-4 ${un ? "bg-slate-50 border-slate-200" : "bg-rose-50/60 border-rose-200"}`}>
          <div className="flex items-baseline justify-between">
            <span className={`text-sm font-semibold ${un ? "text-slate-500" : "text-rose-900"}`}>{un ? "Not assigned" : `${p.name} paid`}</span>
            <span className="num text-xl font-bold text-slate-900" data-testid={`paid-by-total-${p.name}`}>{rs(p.amount)}</span>
          </div>
          <div className="mt-3 grid grid-cols-2 gap-2 text-xs">
            <div className="rounded-lg bg-white/70 px-3 py-2"><div className="text-slate-500">1st – 15th</div><div className="num font-semibold text-slate-800" data-testid={`paid-by-h1-${p.name}`}>{rs(h1)}</div></div>
            <div className="rounded-lg bg-white/70 px-3 py-2"><div className="text-slate-500">16th – end</div><div className="num font-semibold text-slate-800" data-testid={`paid-by-h2-${p.name}`}>{rs(h2)}</div></div>
          </div>
        </div>
      );
    })}
  </div>
);

export const PaidByDateTable = ({ days, paidBy }) => {
  const total = paidBy.reduce((a, p) => a + p.amount, 0);
  return (
    <table className="w-full text-sm" data-testid="paid-by-date-table">
      <thead className="border-b"><tr><Th>Date</Th>{paidBy.map((p) => <Th key={p.name} r>{p.name === "Unassigned" ? "Not assigned" : `${p.name} paid`}</Th>)}<Th r>Total</Th></tr></thead>
      <tbody>{days.map((d) => {
        const row = paidBy.map((p) => p.by_date[d.date] || 0), t = row.reduce((a, v) => a + v, 0);
        return (
          <tr key={d.date} className={`border-b border-slate-100 ${t ? "" : "text-slate-400"}`}>
            <Td>{fmtDate(d.date, { weekday: "short", day: "2-digit", month: "short" })}</Td>
            {row.map((v, i) => <Td key={i} r>{v ? rs(v) : "—"}</Td>)}<Td r b>{t ? rs(t) : "—"}</Td>
          </tr>
        );
      })}</tbody>
      <tfoot className="bg-amber-50 font-bold text-amber-900"><tr><Td>Total</Td>{paidBy.map((p) => <Td key={p.name} r>{rs(p.amount)}</Td>)}<Td r>{rs(total)}</Td></tr></tfoot>
    </table>
  );
};

export const PaidByHeadTable = ({ expenses, paidBy }) => {
  const heads = expenses.filter((e) => e.kind === "variable" && e.amount);
  return (
    <table className="w-full text-sm" data-testid="paid-by-head-table">
      <thead className="border-b"><tr><Th>Expense head</Th>{paidBy.map((p) => <Th key={p.name} r>{p.name === "Unassigned" ? "Not assigned" : p.name}</Th>)}<Th r>Total</Th></tr></thead>
      <tbody>{heads.map((h) => (
        <tr key={h.id} className="border-b border-slate-100">
          <Td>{h.name}</Td>{paidBy.map((p) => <Td key={p.name} r>{p.by_head[h.id] ? rs(p.by_head[h.id]) : "—"}</Td>)}<Td r b>{rs(h.amount)}</Td>
        </tr>))}</tbody>
      <tfoot className="bg-amber-50 font-bold text-amber-900"><tr><Td>Total</Td>{paidBy.map((p) => <Td key={p.name} r>{rs(p.amount)}</Td>)}<Td r>{rs(heads.reduce((a, h) => a + h.amount, 0))}</Td></tr></tfoot>
    </table>
  );
};
